<template>
  <section class="px-16 sm-max:px-5 mt-6 pb-6">
    <div class="lg:text-19 md:text-17 sm:text-15 md-max:text-base" v-html="message"></div>

    <div class="inline-block mt-8 md-max:mt-4">
      <nuxt-img
          class="m-auto"
          width="400"
          height="213"
          loading="lazy"
          :alt="imageAlt"
          format="webp"
          :src="imageSrc"
      ></nuxt-img>
    </div>

    <div class="lg:text-19 md:text-17 sm:text-15 md-max:text-base mt-3" v-html="signatoryName"></div>

    <div class="lg:text-19 md:text-17 sm:text-15 md-max:text-base mt-5" v-html="signatoryPosition"></div>
  </section>
</template>

<script setup>

defineProps({
  message: {
    type: String,
    default: 'Sincerely,'
  },
  imageSrc: {
    type: String,
    default: '/assets/images/dr_img_signature2.jpg'
  },
  imageAlt: {
    type: String,
    default: 'top-influencers'
  },
  signatoryName: {
    type: String,
    default: 'Dr. Charles Livingston'
  },
  signatoryPosition: {
    type: String,
    default: 'Founder of Lifeboost Coffee'
  }
})

defineBuilderComponent({
    friendlyName: "FounderLifeBoost",
    canHaveChildren: true,
    inputs: [
        {
            name: "message",
            type: "richText",
            defaultValue: "Sincerely,"
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/dr_img_signature2.jpg"
        },
        {
            name: "imageAlt",
            type: "string",
            defaultValue: "top-influencers"
        },
        {
            name: "signatoryName",
            type: "richText",
            defaultValue: "Dr. Charles Livingston"
        },
        {
            name: "signatoryPosition",
            type: "richText",
            defaultValue: "Founder of Lifeboost Coffee"
        }
    ]
});
</script>